import React from 'react';
import AnimationRevealPage from 'helpers/AnimationRevealPage.js';
import tw from 'twin.macro';
import Footer from 'components/footers/MiniCenteredFooter.js';
import ContactUsForm from 'components/forms/TwoColContactUsWithIllustrationFullForm.js';
import ContactDetails from 'components/cards/ThreeColContactDetails.js';
import NavBar from 'components/navbars/basic.js';

const Address = tw.span`leading-relaxed`;
const AddressLine = tw.span`block`;

export default () => {
  return (
    <AnimationRevealPage>
      {/* <Header /> */}
      <NavBar />
      <ContactDetails
        cards={[
          {
            title: 'Phone Number',
            description: (
              <>
                <Address>
                  <AddressLine>+255 673 599 117</AddressLine>
                </Address>
              </>
            ),
          },
          {
            title: 'Email',
            description: (
              <>
                <Address>
                  <AddressLine>brighthopeschools06@gmail.com</AddressLine>
                </Address>
              </>
            ),
          },
          {
            title: 'Location',
            description: (
              <>
                <Address>
                  <AddressLine>
                    150m off Ununio Road, Seamic Drive, Kunduchi, Dar es Salaam,
                    Tanzania
                  </AddressLine>
                </Address>
              </>
            ),
          },
        ]}
      />
      <ContactUsForm />
      <Footer />
    </AnimationRevealPage>
  );
};
